import { v4 } from 'uuid';

const useUuid = (): string => {
  return v4();
};

export default useUuid;
